(() => {
  const publish = (name, payload = {}) => {
    const event = {
      event: name,
      ...payload,
      page_path: window.location.pathname,
    };

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(event);

    if (window.Shopify?.analytics?.publish) {
      window.Shopify.analytics.publish(name, payload);
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.closest('.osc-filter__panel')) return;

    const selectedFilters = [...form.querySelectorAll('input[type="checkbox"]:checked')]
      .map((input) => `${input.name}:${input.value}`)
      .slice(0, 20);
    const sort = form.querySelector('[name="sort_by"]')?.value || '';

    publish('scent_filter', {
      selected_filters: selectedFilters.join('|'),
      selected_filter_count: selectedFilters.length,
      sort_by: sort,
    });
  });

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;

    const finderLink = event.target.closest('[data-scent-finder-choice]');
    if (finderLink instanceof HTMLAnchorElement) {
      publish('scent_finder_complete', {
        scent_direction: finderLink.dataset.scentFinderChoice || '',
        destination: new URL(finderLink.href, window.location.origin).pathname,
      });
      return;
    }

    const productLink = event.target.closest('.osc-card__link');
    if (productLink instanceof HTMLAnchorElement) {
      publish('select_item', {
        item_list_name: document.querySelector('.osc-hero h1')?.textContent?.trim() || 'Catalog',
        item_url: new URL(productLink.href, window.location.origin).pathname,
      });
    }
  });
})();
